export class SelectionCriterion {
  criterionType: string;
  description?: string;
  secondPhase?: boolean;
}
